@if (showLabels) {
  @for (label of labels; track label) {
    @if (!!label && label.name) {
      <div [class.pm-hidden-text]="smallLabels$ | async" class="pm-label" [style.background-color]="label.color" [matTooltip]="label.name" matTooltipPosition="above" [matTooltipDisabled]="!!context.activation" id="label-{{label.id}}"
      [class.contrast-dark]="isDark(label)" [class.inherited-label]="!!label.default" [class.pm-dim-label]="dimLabel(label)">{{label.name}}</div>
    }
  }
}
